
import "./index.css";

const TestingBg = () => {
    return (
        <div className="image-container">
                <h1>jdjsjd</h1>
        </div>
    )
}

export default TestingBg;